import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { push } from "react-router-redux";
import * as actions from "MODULES/parts/actions";
import {
  ConfirmDelete,
  ClipboardCopy,
  Icon,
  NoteTooltip as IconTooltip,
  Authorized
} from "MODULES/shared/components";
import DropDown, { DropDownItem } from "MODULES/shared/components/DropDown";
import classNames from "classnames";
import { getPartNumberColorClassNameByTierType } from "MODULES/shared/helpers";
import {
  ADMIN,
  ROLE,
  ROLES,
  WAREHOUSE,
  WAREHOUSE_LOGISTICS_DIRECTOR
} from "MODULES/users/constants";
import { without } from "lodash";
import Edit from "./Edit";

class AlternateTag extends React.Component {
  static propTypes = {
    alternate: PropTypes.instanceOf(Object).isRequired,
    destroy: PropTypes.func.isRequired,
    navToPart: PropTypes.func.isRequired,
    part: PropTypes.shape({}),
    user: PropTypes.shape({})
  };

  state = {
    removeModalOpen: false,
    editModalOpen: false
  };

  openRemoveModal = () => this.setState({ removeModalOpen: true });

  closeRemoveModal = () => this.setState({ removeModalOpen: false });

  openEditModal = () => this.setState({ editModalOpen: true });

  closeEditModal = () => this.setState({ editModalOpen: false });

  render() {
    const { alternate, destroy, navToPart, part } = this.props;
    let onLabelClick = () => {};
    let labelColor = "#FFFFFF";

    if (alternate.alternate_part_id) {
      labelColor = "#FF9800";
      onLabelClick = () => navToPart(alternate.alternate_part_uuid);
    }

    const labelStyle = {
      cursor: onLabelClick ? "pointer" : "default",
      color: labelColor,
      fontSize: "1.25em"
    };

    const canEdit =
      !part.master_part_lock ||
      alternate.alternate_type !== "exact" ||
      this.props.user[ROLE] === ADMIN;

    const DropDowns = () => [
      <DropDownItem onClick={this.openEditModal}>
        <Icon name="pencil" fixed /> Change Type
      </DropDownItem>,
      <DropDownItem onClick={this.openRemoveModal}>
        <Icon name="close" fixed /> Remove
      </DropDownItem>
    ];

    const labelClassName = classNames(
      "btn btn-xs btn-default",
      getPartNumberColorClassNameByTierType(alternate.tier_type)
    );

    return (
      <div>
        <div
          className="btn-group"
          style={{ marginBottom: 4, marginRight: 2, display: "table-cell" }}
        >
          <button
            style={labelStyle}
            type="button"
            className={labelClassName}
            onClick={onLabelClick}
          >
            {alternate.sellable && (
              <IconTooltip
                note="In Stock"
                url="https://aero-zone-assets.s3.amazonaws.com/inventory.png"
              />
            )}
            {alternate.name}
          </button>
          <Authorized
            roles={without(ROLES, WAREHOUSE)}
            subroles={[WAREHOUSE_LOGISTICS_DIRECTOR]}
          >
            <DropDown
              icon={`fa ${canEdit ? "fa-ellipsis-v" : "fa-lock"}`}
              dropdownStyles={{ display: "inline" }}
              buttonClasses="btn btn-xs btn-default dropdown-toggle"
              containerClasses="btn-group"
              iconStyles={{ fontSize: "1.5em", paddingTop: "0.2em" }}
            >
              {canEdit ? <DropDowns /> : null}
            </DropDown>
          </Authorized>
          <ClipboardCopy name={alternate.name} type="PN" iconFontSize="1em" />
        </div>
        <ConfirmDelete
          onConfirm={destroy}
          close={this.closeRemoveModal}
          open={this.state.removeModalOpen}
        >
          <strong>Heads up!</strong> Are you sure you want to delete this?
        </ConfirmDelete>
        <Edit
          alternate={alternate}
          close={this.closeEditModal}
          open={this.state.editModalOpen}
        />
      </div>
    );
  }
}

export default connect(
  state => ({ user: state.userDetail.toJS().user }),
  (dispatch, ownProps) => ({
    destroy: () => dispatch(actions.deleteAlternate(ownProps.alternate.id)),
    navToPart: partId => dispatch(push(`/parts/${partId}`))
  })
)(AlternateTag);



// WEBPACK FOOTER //
// ./app/modules/parts/components/Detail/Alternates/Alternate.jsx